import React from 'react';

import { Table } from './styles';

export function Tabela(props) {
	const { children } = props;
	return <Table>{children}</Table>;
}
